module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-5"
    }
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "13em",
      "line-height": "1.6em"
    },
    attrs: {
      "id": "pz5-1"
    }
  }, [_c('i', [_vm._v("I dedicate this book to my parents,"), _c('br'), _vm._v("\n\t\t\t\t\tGene and Fayrene Catterton,"), _c('br'), _vm._v("\n\t\t\t\t\twith love and appreciation for their"), _c('br'), _vm._v("\n\t\t\t\t\tprayers, perseverance, and faithfulness.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0